(() => {
  const SELECTOR = '[data-promotion-countdown]';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function localDateTimeToTimestamp(dateString, timeString) {
    if (!dateString) return null;

    const dateMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const timeMatch = (timeString || '00:00').match(/^(\d{2}):(\d{2})$/);

    if (!dateMatch || !timeMatch) return null;

    const year = Number(dateMatch[1]);
    const month = Number(dateMatch[2]);
    const day = Number(dateMatch[3]);
    const hour = Number(timeMatch[1]);
    const minute = Number(timeMatch[2]);

    if (
      month < 1 ||
      month > 12 ||
      day < 1 ||
      day > 31 ||
      hour < 0 ||
      hour > 23 ||
      minute < 0 ||
      minute > 59
    ) {
      return null;
    }

    return new Date(
      year,
      month - 1,
      day,
      hour,
      minute,
      0
    ).getTime();
  }

  function initCountdown(element) {
    if (!element || element.dataset.countdownInitialized === 'true') {
      return;
    }

    element.dataset.countdownInitialized = 'true';

    const startDate = element.dataset.startDate || '';
    const startTime = element.dataset.startTime || '00:00';

    const endDate = element.dataset.endDate || '';
    const endTime = element.dataset.endTime || '23:59';

    const normalLabel =
      element.dataset.label || 'SALE ENDS IN';

    const finalLabel =
      element.dataset.finalLabel || 'FINAL HOURS';

    const finalHours =
      Number(element.dataset.finalHours || 24);

    const hideAfterExpiry =
      element.dataset.hideAfterExpiry !== 'false';

    const showDays =
      element.dataset.showDays !== 'false';

    const showSeconds =
      element.dataset.showSeconds !== 'false';

    const labelElement =
      element.querySelector('[data-countdown-label]');

    const daysElement =
      element.querySelector('[data-countdown-days]');

    const hoursElement =
      element.querySelector('[data-countdown-hours]');

    const minutesElement =
      element.querySelector('[data-countdown-minutes]');

    const secondsElement =
      element.querySelector('[data-countdown-seconds]');

    const startTimestamp = startDate
      ? localDateTimeToTimestamp(startDate, startTime)
      : null;

    const endTimestamp =
      localDateTimeToTimestamp(endDate, endTime);

    if (!endTimestamp) {
      element.hidden = true;
      return;
    }

    let intervalId = null;

    function stopTimer() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    function expireCountdown() {
      if (hideAfterExpiry) {
        element.hidden = true;
        stopTimer();
        return;
      }

      if (daysElement) daysElement.textContent = '00';
      if (hoursElement) hoursElement.textContent = '00';
      if (minutesElement) minutesElement.textContent = '00';
      if (secondsElement) secondsElement.textContent = '00';

      element.hidden = false;
      stopTimer();
    }

    function update() {
      const now = Date.now();

      if (startTimestamp && now < startTimestamp) {
        element.hidden = true;
        return;
      }

      const remaining = endTimestamp - now;

      if (remaining <= 0) {
        expireCountdown();
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const totalMinutes = Math.floor(totalSeconds / 60);
      const totalHours = Math.floor(totalMinutes / 60);

      const days = Math.floor(totalHours / 24);

      const hours = showDays
        ? totalHours % 24
        : totalHours;

      const minutes = totalMinutes % 60;
      const seconds = totalSeconds % 60;

      if (daysElement) {
        daysElement.textContent = pad(days);
      }

      if (hoursElement) {
        hoursElement.textContent = pad(hours);
      }

      if (minutesElement) {
        minutesElement.textContent = pad(minutes);
      }

      if (secondsElement) {
        secondsElement.textContent = pad(seconds);
      }

      const isFinalHours =
        remaining <= finalHours * 60 * 60 * 1000;
        const daysUnit = daysElement
  ? daysElement.closest('.promotion-countdown__unit')
  : null;

const daysSeparator = daysUnit
  ? daysUnit.nextElementSibling
  : null;

if (daysUnit) {
  daysUnit.style.display = isFinalHours ? 'none' : '';
}

if (
  daysSeparator &&
  daysSeparator.classList.contains('promotion-countdown__separator')
) {
  daysSeparator.style.display = isFinalHours ? 'none' : '';
}

      element.classList.toggle(
        'is-final-hours',
        isFinalHours
      );

      if (labelElement) {
        labelElement.textContent =
          isFinalHours && finalLabel
            ? finalLabel
            : normalLabel;
      }

      element.hidden = false;
    }

    update();

    intervalId = window.setInterval(
      update,
      showSeconds ? 1000 : 60000
    );

    element._promotionCountdownDestroy = () => {
      stopTimer();
      delete element.dataset.countdownInitialized;
    };
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();